import PropTypes from 'prop-types'
import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import classes from './index.module.scss'
import { Vertical } from './Vertical'

export const SideBar = ({
  list,
  renderBottomComponent,
  scrollId,
  activeItem,
}) => {
  const renderContentResponsive = () => {
    return (
      <>
        <Vertical list={list} activeItem={activeItem} />
        <div className="flex1">
          <div className="h100 flexColumn">{renderContent()}</div>
        </div>
      </>
    )
  }

  const renderContent = () => {
    return (
      <div id={scrollId} className="flex1">
        <ScrollComponent id={scrollId}>
          <div className={'flexColumn h100'}>
            <div className={`${classes.center} flex1 positionRelative`}>
              {renderBottomComponent()}
            </div>
          </div>
        </ScrollComponent>
      </div>
    )
  }

  return (
    <Element className={classes.container}>{renderContentResponsive()}</Element>
  )
}

SideBar.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isI18n: PropTypes.bool,
    }),
  ),
  renderBottomComponent: PropTypes.func,
}

SideBar.defaultProps = {
  renderBottomComponent: () => {},
}
